module.exports = __webpack_public_path__ + "static/media/frame-contact.6b422561.png";